import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Constants } from '../../models/constants';
import { GetCommonStudyDescription } from '@app/api-module/control-centre-api-client';

@Component({
    selector: 'app-studies',
    templateUrl: './studies.component.html'
})
export class StudiesComponent implements OnInit {
    constructor(private readonly formBuilder: UntypedFormBuilder) {}

    // A list of forms with controls: modality, studyId, noOfImages, accessionNumber and studyDescription
    @Input()
    studyForms: UntypedFormArray;

    @Input()
    commonStudies: GetCommonStudyDescription[];

    @Input()
    modalityList: string[];

    @Input()
    studiesGroups: Map<string, GetCommonStudyDescription[]>;

    ngOnInit() {
        this.addStudy();
    }

    addStudy() {
        this.studyForms.push(this.newStudyForm());
    }

    onStudyChange($event: { studyId: number; rowIndex: number }) {
        const studyIdSelected = Number($event.studyId);
        const rowSelected = Number($event.rowIndex);
        if (this.studyForms.controls.filter(child => (child as UntypedFormGroup).controls.studyId.value === studyIdSelected).length > 1) {
            (this.studyForms.at(rowSelected) as UntypedFormGroup).controls.studyId.setErrors({ duplicatedstudy: true });
        }

        const index = this.commonStudies.findIndex(({ studyId }) => studyId === studyIdSelected);

        if (index < 0) {
            // Should never happen
        } else {
            (this.studyForms.at(rowSelected) as UntypedFormGroup).controls.studyDescription.setValue(this.commonStudies[index].description);
        }
    }

    private newStudyForm(): UntypedFormGroup {
        return this.formBuilder.group({
            modality: [null, Validators.required],
            studyDescription: [null, [Validators.required]],
            noOfImages: [null, [Validators.required, Validators.min(1), Validators.max(9999999)]],
            accessionNumber: [null, [Validators.maxLength(50), Validators.pattern(Constants.AccessionNumberPattern)]],
            studyId: [null, Validators.nullValidator]
        });
    }

    deleteStudy(index: number) {
        if (this.studyForms.length <= 1) {
            return;
        }

        this.studyForms.removeAt(index);
    }
}
